import {ref, Ref} from "vue"

const agentId: Ref<string | undefined> = ref()

export default agentId